export const FormBuilderBlock = {
    block(block){
        return {
            name : 'Form builder',
            fields: block.fields ?? [],
            type: 'form-builder',
            uuid: block.uuid ?? 0,
            lock: block.lock ?? 0,
            connected_parent_conditional_id: block.connected_parent_conditional_id ?? [],
            role_id: block.role_id ?? 0
        }
    }
}